import { HStack, Pressable, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { SelectTransactionItemProps } from "./types";
import { TransactionItemTypeEnum } from "@repo/core/constants/transactions";
import { operationColor, operationName } from "./utils";

export const SelectTransactionItem = ({
  authorizationId,
  card,
  value,
  operation,
  isSelected,
  onChange
}: SelectTransactionItemProps) => {
  return (
    <Pressable
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      p="$3.5"
      borderWidth="$1"
      borderColor={isSelected ? "$primary700" : "$borderLight100"}
      borderRadius="$lg"
      bg={isSelected ? "$primary0" : "$backgroundLight50"}
      onPress={() => onChange?.(authorizationId!.toString())}
    >
      <HStack flex={1} alignItems="center" space="sm">
        {isSelected ? (
          <VStack
            w="$4"
            h="$4"
            borderRadius="$full"
            borderWidth="$2"
            borderColor="$primary700"
            alignItems="center"
            justifyContent="center"
          >
            <VStack w="$2" h="$2" borderRadius="$full" bg="$primary700" />
          </VStack>
        ) : (
          <VStack
            w="$4"
            h="$4"
            borderRadius="$full"
            borderWidth="$2"
            borderColor="$primary700"
          />
        )}
        <Text fontSize="$xs">{authorizationId}</Text>
      </HStack>
      <VStack flex={0.8} alignItems="center" pr="$2">
        <Text
          color={operationColor[operation as TransactionItemTypeEnum]}
          fontSize="$xs"
        >
          {operationName[operation as TransactionItemTypeEnum]}
        </Text>
      </VStack>
      <VStack flex={0.8} alignItems="center" pr="$2">
        <Text fontSize="$xs">{card}</Text>
      </VStack>
      <VStack flex={1} alignItems="flex-end">
        <Text fontSize="$xs" fontWeight={500}>
          {numberToBrl(value!)}
        </Text>
      </VStack>
    </Pressable>
  );
};
